import React from 'react'
import Layout from '../../components/LayoutNew'
import { graphql, useStaticQuery } from 'gatsby'
import HomeSection3 from '../../containers/HomeSection3'
import ProductSection1 from '../../containers/ProductSection1'
import ProductSection2 from '../../containers/ProductSection2'
import Img from 'gatsby-image'

import './privateDomain.scss'

const PrivateDomainPage = () => {
  const pageColor = '#F8B137'
  const { pic1, pic2, pic3 } = useStaticQuery(graphql`
    query {
      pic1: file(
        relativePath: { eq: "systemProduct/privateDomain/siyu-01.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic2: file(
        relativePath: { eq: "systemProduct/privateDomain/siyu-02.png" }
      ) {
        id
        childImageSharp {
          fluid(maxWidth: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic3: file(
        relativePath: { eq: "systemProduct/privateDomain/siyu-03.png" }
      ) {
        id
        childImageSharp {
          fluid(maxWidth: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Layout
      className="privateDomain-page"
      headerBackground={pageColor}
      headerTheme="white"
    >
      <ProductSection1
        className="section-0"
        background={pageColor}
        title="私域解决方案"
        subTitleArray={[
          '再惠为本地生活商家提供私域流量解决方案，帮助商户加强到店流量留存和转化。通过丰富的营销活动、精准的营销决策，实现高回头高转化，提升顾客的忠诚度',
          '同时与银行积分平台、音频内容平台进行合作，打通线上线下积分，通过收银、支付、优惠券多种场景，实现餐厅与积分平台或音频内容平台的双赢。',
        ]}
      />
      <ProductSection2
        id="privateDomain-1"
        className="section-1"
        title="智能会员管理"
        subTitleArray={[
          '结合会员画像、会员数据分析，帮助商户切分顾客，进行分级管理和智能运营',
          '针对不同会员，自动推荐使用不同的营销方式',
          '操作简便，一键设置，自动运行',
        ]}
        image={
          <div style={{ width: '562px' }}>
            <Img fluid={pic1.childImageSharp.fluid} alt="智能会员管理" />
          </div>
        }
      />
      <ProductSection2
        id="privateDomain-2"
        className="section-2"
        type="row-reverse"
        title="智能社群管家"
        subTitleArray={[
          '基于企业微信客户群和客户关系管理，帮助商户自动进行社群管理',
          '提供渠道活码、活动裂变等工具引导入群',
          '通过抽奖、品牌宣传、群游戏等工具进行留存促活，从而盘活社群',
          '通过智能营销、秒杀、拼团、砍价等活动完成转化复购',
        ]}
        image={
          <div style={{ width: '487px' }}>
            <Img fluid={pic2.childImageSharp.fluid} alt="智能社群管家" />
          </div>
        }
      />
      <ProductSection2
        id="privateDomain-3"
        className="section-1"
        title="多场景多业态全覆盖"
        subTitle="提供私域商城、私域外卖、堂食点餐、预订等多种解决方案，完整覆盖多种业态和多种场景"
        image={
          <div style={{ width: '487px' }}>
            <Img fluid={pic3.childImageSharp.fluid} alt="多场景多业态全覆盖" />
          </div>
        }
      />
      <HomeSection3 />
    </Layout>
  )
}

export default PrivateDomainPage
